module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-settings-up@2x.png?1.0.17";